export default __webpack_public_path__ + "static/media/touchofdeath.7b1ccec0.png";